// eslint-disable-next-line no-unused-vars
import React from 'react';
import { func } from 'prop-types';
import styled from '@emotion/styled';
import { ChevronRight, ChevronLeft } from 'lucide-react';

const StyledButtonGroup = styled.div`
  position: absolute;
  top: -50px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 16px;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: #FF7900;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;

    &.disable {
      background: #e8e8e8;
    }
  }
`;

const ButtonGroup = ({ next, previous, ...rest }) => {
  const { carouselState: { currentSlide, totalItems, slidesToShow } } = rest;
  const isLastSlide = currentSlide >= totalItems - slidesToShow;
  return (
    <StyledButtonGroup>
      <button
        type="button"
        aria-label="Previous slide"
        className={ currentSlide === 0 ? 'disable' : '' }
        onClick={ () => previous() }
      >
        <ChevronLeft size={ 24 } />
      </button>
      <button
        type="button"
        aria-label="Next slide"
        className={ isLastSlide ? 'disable' : '' }
        onClick={ () => next() }
      >
        <ChevronRight size={ 24 } />
      </button>
    </StyledButtonGroup>
  );
};

ButtonGroup.propTypes = {
  next: func.isRequired,
  previous: func.isRequired,
};

export default ButtonGroup;
